module.exports = __webpack_public_path__ + "img/jibie_top2.2e7b6aad.png";